import kale from "../assets/kale.png";
import legumes from "../assets/legumes.png";
import wheat from "../assets/wheat.png";
import teddybear from "../assets/teddybear.png";
import tireswing from "../assets/tireswing.png";
import pokemon from "../assets/pokemon.png";

export const petToys = [
    {
        "name": "Teddy Bear",
        "description": "A cute teddy bear.",
        "price": 3,
        "imageUrl": teddybear
    },
    {
        "name": "Tire Swing",
        "description": "WEEEEE!",
        "price": 8,
        "imageUrl": tireswing
    },
    {
        "name": "Pikachu",
        "description": "A cute Pikachu plush.",
        "price": 3,
        "imageUrl": pokemon
    },
]

export const petFood = [
    {
        "name": "Wheat",
        "description": "Cows like wheat...?",
        "price": 3,
        "imageUrl": wheat
    },
    {
        "name": "Legumes",
        "description": "Yum...legumes...",
        "price": 3,
        "imageUrl": legumes
    },
    {
        "name": "Kale",
        "description": "Tastes like grass!",
        "price": 3,
        "imageUrl": kale
    },
]
